import React from 'react';
import {connect} from "react-redux";
import * as costActions from "../../actions/cost";
import * as companyActions from "../../actions/company";
import l10n from "../../l10n/localization";
import Loader from "../common/Loader";
import validation from '../../validation/cost';
import Validate from 'validate.js';
import SelectCompanies from "./fields/SelectCompanies";
import * as utils from "../../utils/cost";
import DateTimePicker from "./fields/DateTimePicker";
import * as utilsUtils from "../../utils/utils";
import CWForm from "./CWForm";
import UploadFile from "./fields/UploadFile";

class CostForm extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            item: this.props.item.item,
            fog: this.props.item.fog,
            schema: {
                type: "object",
                properties: {
                    invoiceNumber: {
                        title: l10n.cost.invoiceNumber,
                        type: "string",
                    },
                    label: {
                        title: l10n.cost.label,
                        type: "string",
                    },
                    company: {
                        title: l10n.cost.company,
                        type: "string",
                        depth: this.props.depth,
                        openDrawer: this.props.openDrawer
                    },
                    totalCost: {
                        title: l10n.cost.totalCost,
                        type: "number",
                    },
                    invoiceFile: {
                        title: l10n.cost.invoiceFile,
                        type: "string",
                        format: "data-url",
                        item: this.props.item.item,
                        dispatch: this.props.dispatch,
                        postUpdate : this.handlePostUpload.bind(this)
                    }
                }
            },
            uiSchema: {
                id: {"ui:widget": "hidden"},
                company: {
                    "ui:field": "selectCompanies",
                },
                totalCost: {
                },
                invoiceFile: {
                    "ui:field": "uploadFile",
                }
            },
            fields: {
                selectCompanies: SelectCompanies,
                dateTimePicker: DateTimePicker,
                uploadFile: UploadFile
            },
            isDirty: false
        }
    }

    componentWillUnmount() {
        this.props.dispatch(costActions.clearFormDataCost());
    }

    componentWillMount() {
        this.props.dispatch(costActions.updateFormDataCost(utils.costToForm(this.props.item.item)));
    }

    componentDidMount() {
        this.props.dispatch(companyActions.fetchCompanies(true));
        //this.props.dispatch(currencyActions.fetchCurrencies(true));
    }


    componentWillReceiveProps(nextProps) {
        if (utilsUtils.notNullNorUndefined(nextProps.item.item)) {
            if (this.props.item.item !== this.props.costs.getById(nextProps.item.item.id)) {
                this.setState({
                    item: utilsUtils.notNullNorUndefined(nextProps.item) ? this.props.costs.getById(nextProps.item.item.id) : {},
                    fog: nextProps.item.fog
                });
            }
        } else if (parseInt(this.props.newlyCreatedElement, 10) > 0 ) {
            if (this.props.item.item !== this.props.costs.getById(this.props.newlyCreatedElement)) {
                this.setState({
                    item: utilsUtils.notNullNorUndefined(nextProps.item) ? this.props.costs.getById(this.props.newlyCreatedElement) : {},
                    fog: nextProps.item.fog
                });
            }
        }
    }

    onSubmit = ({formData}) => {
        formData.totalCost = utilsUtils.precisionRound(formData.totalCost);
        let form = Object.assign({}, {...formData});

        delete form.creationDate;
        form.fog = this.state.fog.id;
        if (utilsUtils.notNullNorUndefined(this.state.item) && (utilsUtils.notNullNorUndefined(this.state.item.id) || utilsUtils.notNullNorUndefined(this.props.newlyCreatedElement))) {
            if (utilsUtils.notNullNorUndefined(this.props.newlyCreatedElement)) {
                this.setState({item: {...formData, id: this.props.newlyCreatedElement}}, () => {
                    form.id = this.props.newlyCreatedElement;
                    this.props.dispatch(costActions.edit(form, this.state.fog.id));
                })
            } else {
                this.setState({item: formData}, () => {
                    this.props.dispatch(costActions.edit(form, this.state.fog.id));
                })
            }
        } else {
            this.setState({item: formData}, () => {
                this.props.dispatch(costActions.add(form));
            })
        }
        this.props.dispatch(costActions.updateFormDataCost(formData));
        this.setState((state) => {return {...state, isDirty: false};});
    };

    validate = (formData, errors) => {
        let validationErrors = Validate(formData, validation, {fullMessages: false});

        if (validationErrors !== undefined) {
            for (let key in validationErrors) {
                if (validationErrors.hasOwnProperty(key)) {
                    if (errors[key] !== undefined) {
                        for (let i = 0; i < validationErrors[key].length; i++) {
                            errors[key].addError(validationErrors[key][i]);
                        }
                    }
                }
            }
        }
        return errors;
    };

    handlePostUpload(fileUrl) {
        this.props.dispatch(costActions.updateFormDataCost({...this.props.formData, invoiceFile: fileUrl}));
    }

    handleChange = (formData) => {
        this.props.dispatch(costActions.updateFormDataCost(formData.formData));
        if(!this.state.isDirty) {
            this.setState((state) => {return {...state, isDirty: true};});
        }
    };

    handleError = () => {
        this.props.dispatch(costActions.errorMessage(l10n.validation.form_error));
    };

    render() {
        if (this.props.loading || this.props.saving) {
            return (<div><Loader /></div>)
        }

        let formClassName = (this.state.isDirty) ? 'cost-form dirty':'cost-form';

        return (
            <div className={formClassName}>
                <h1>Cost {utilsUtils.notNullNorUndefined(this.state.fog) && utilsUtils.notNullNorUndefined(this.state.fog.vessel) && "- " + this.state.fog.vessel.name + " " + this.state.fog.vessel.year}</h1>
                <CWForm
                    schema={this.state.schema}
                    uiSchema={this.state.uiSchema}
                    formData={this.props.formData}
                    fields={this.state.fields}
                    showErrorList={false}
                    liveValidate={true}
                    validate={this.validate}
                    onError={this.handleError}
                    onChange={({formData})=> {this.handleChange({formData})}}
                    onSubmit={this.onSubmit}>
                    <div>
                        <button type="submit" className="btn btn-info validate" disabled={this.props.saving || this.props.fileLoading}>{l10n.common.save}</button>
                    </div>
                </CWForm>
            </div>
        )
    }
}

export default connect((state) => {
    return Object.assign({}, {
        loading: state.cost.loading,

        fileLoading : state.files.loading,

        saving: state.cost.saving,
        costs: state.cost.costs,

        newlyCreatedElement: state.creation.newlyCreatedCost,
        formData: state.cost.formData
    });
})(CostForm);



// WEBPACK FOOTER //
// ./src/components/forms/CostForm.js